import axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios'
import { config } from '@/config/config'

// 创建axios实例
const api = axios.create({
  baseURL: 'https://aivitahelper.xyz:8081',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 创建用于获取资源的axios实例
export const resourceApi = axios.create({
  baseURL: 'https://aivitahelper.xyz:8081',
  timeout: 10000,
  responseType: 'blob'  // 用于处理图片等二进制资源
})

// 请求拦截器
const addAuthHeader = (config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

api.interceptors.request.use(addAuthHeader, error => Promise.reject(error))
resourceApi.interceptors.request.use(addAuthHeader, error => Promise.reject(error))

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      // 服务器返回错误状态码
      switch (error.response.status) {
        case 400:
          error.message = error.response.data.message || '请求参数错误';
          break;
        case 401:
          error.message = '未授权，请重新登录';
          // 处理登出逻辑
          logout();
          break;
        case 403:
          error.message = '访问被拒绝，请重新登录';
          // 处理登出逻辑
          logout();
          break;
        case 404:
          error.message = '请求错误，未找到该资源';
          break;
        case 500:
          error.message = '服务器内部错误';
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else if (error.request) {
      error.message = '网络错误，请检查您的网络连接';
    } else {
      error.message = '请求失败';
    }
    return Promise.reject(error);
  }
)

// 登出函数
function logout() {
  localStorage.removeItem('token');
  // 重定向到登录页
  window.location.href = '/login';
}

export default api 